(function () {
  'use strict';

  var CACHE_KEY = 'avarrio_product_prices';
  var CACHE_MAX_AGE = 10 * 60 * 1000; // 10 minutes
  var CACHE_FRESH_AGE = 1 * 60 * 1000; // 1 minute
  var POLL_INTERVAL = 60 * 1000; // 60 seconds
  var FETCH_TIMEOUT = 5000;

  var config = window.avarrioPrices;
  if (!config || !config.apiUrl) return;

  var intervalId = null;

  window.avarrio = window.avarrio || {};
  window.avarrio.productPrices = null;

  function getCached() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (Date.now() - cached._cachedAt > CACHE_MAX_AGE) return null;
      return cached;
    } catch (e) {
      return null;
    }
  }

  function isCacheFresh() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return false;
      var cached = JSON.parse(raw);
      return Date.now() - cached._cachedAt <= CACHE_FRESH_AGE;
    } catch (e) {
      return false;
    }
  }

  function setCache(data) {
    try {
      data._cachedAt = Date.now();
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch (e) {
      // localStorage full or unavailable
    }
  }

  function updatePrices(data) {
    var prices = data.prices;
    if (!prices) return;

    window.avarrio.productPrices = prices;

    var elements = document.querySelectorAll('[data-variant-price]');
    elements.forEach(function (el) {
      var variantId = el.getAttribute('data-variant-price');
      var priceData = prices[variantId];
      if (!priceData) return;

      var quantity = el.getAttribute('data-line-quantity');
      if (quantity) {
        // Cart line item: multiply unit price by quantity
        var lineTotal = priceData.price * parseInt(quantity, 10);
        el.textContent = formatPrice(lineTotal);
      } else {
        el.textContent = priceData.formatted;
      }
    });

    if (typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.productPricesUpdate, data);
    }
  }

  function formatPrice(hellers) {
    var czk = Math.round(hellers / 100);
    var str = czk.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
    return str + '\u00A0K\u010D';
  }

  function fetchPrices() {
    if (isCacheFresh()) return;

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT);

    fetch(config.apiUrl, { signal: controller.signal })
      .then(function (res) {
        clearTimeout(timeoutId);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (data.prices) {
          setCache(data);
          updatePrices(data);
        } else {
          throw new Error('Invalid response');
        }
      })
      .catch(function () {
        clearTimeout(timeoutId);
        var cached = getCached();
        if (cached) updatePrices(cached);
      });
  }

  // Re-apply prices after cart DOM re-renders
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(function () {
        var cached = getCached();
        if (cached) updatePrices(cached);
      }, 100);
    });
  }

  // Try cached data first for instant render
  var cached = getCached();
  if (cached) updatePrices(cached);

  // Fetch fresh data immediately
  fetchPrices();

  // Poll
  intervalId = setInterval(fetchPrices, POLL_INTERVAL);

  // Pause polling when tab is hidden, resume when visible
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      clearInterval(intervalId);
      intervalId = null;
    } else {
      fetchPrices();
      intervalId = setInterval(fetchPrices, POLL_INTERVAL);
    }
  });
})();
